<template>
  <div class="card p-5">
    <h3 class="card-title d-flex flex-column align-items-start">
      <span class="card-label fw-bolder fs-3 mb-1">{{ translate("dashboard_audits") }} </span>
      <span class="text-muted fw-bold fs-7">
        {{ translate("dashboard_day_week_month") }}
      </span>
    </h3>
    <nav>
      <div
        class="nav nav-tabs mb-2"
        id="nav-tab"
        role="tablist"
      >
        <button
          class="nav-link active"
          id="nav-home-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-home"
          type="button"
          role="tab"
          aria-controls="nav-home"
          aria-selected="true"
        >
          {{ translate("dashboard_day") }}
        </button>
        <button
          class="nav-link"
          id="nav-profile-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-profile"
          type="button"
          role="tab"
          aria-controls="nav-profile"
          aria-selected="false"
        >
          {{ translate("dashboard_week") }}
        </button>
        <button
          class="nav-link"
          id="nav-contact-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-contact"
          type="button"
          role="tab"
          aria-controls="nav-contact"
          aria-selected="false"
        >
          {{ translate("dashboard_month") }}
        </button>
      </div>
    </nav>
    <div
      class="tab-content h-350px"
      id="nav-tabContent"
    >
      <div
        class="tab-pane fade show active"
        id="nav-home"
        role="tabpanel"
        aria-labelledby="nav-home-tab"
      >
        <div
          v-if="totalCountDay == 0"
          class="h-350px d-flex align-items-center justify-content-center position-relative"
        >
          <BlockUI
            :loading="blockD"
            class="h-350px"
          />
          <span class="fs-6 text-gray-600">{{ translate("dashboard_no_planned_audit_today") }}</span>
        </div>

        <div
          v-else
          class="position-relative overflow-auto"
        >
          <BlockUI
            :loading="blockD"
            class="h-300px"
          />
          <div class="h-300px overflow-auto">
            <div
              class="d-flex align-items-center rounded p-2"
              v-for="audit in dayAuditList"
              :key="audit"
            >
              <span class="bullet bullet-vertical h-40px bg-primary"></span>
              <div class="form-check form-check-custom form-check-solid mx-5">
                <a
                  v-if="audit.StatusCode == 30"
                  :title="translate('dashboard_completed_audit')"
                >
                  <i class="bi bi-check-circle-fill text-primary fs-2"></i
                ></a>
                <a
                  v-else-if="isInThePast(new Date(formatDate(audit.AuditDateTime)))"
                  :title="translate('dashboard_card_icon_out_of_date')"
                >
                  <i class="bi bi-x-circle-fill text-danger fs-2"></i
                ></a>
                <a
                  v-else
                  :title="translate('dashboard_card_icon_upcoming_audit')"
                >
                  <i class="bi bi-clock text-primary fs-2"></i
                ></a>
              </div>
              <div class="flex-grow-1">
                <span class="text-gray-800 fw-bolder fs-6">{{ audit.CustomerName }}</span
                ><span class="text-muted fw-bold d-block">
                  {{ audit.LocationName }}
                </span>
              </div>
              <span class="badge fs-8 fw-bolder badge-light-primary">{{ audit.AuditDateTime.substr(0, 16) }} </span>
            </div>
          </div>

          <div class="mt-3 d-flex">
            <Pagination
              @onPage="onPageD"
              :TotalData="totalCountDay"
            />
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="nav-profile"
        role="tabpanel"
        aria-labelledby="nav-profile-tab"
      >
        <div
          v-if="totalCountWeek == 0"
          class="h-350px w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <BlockUI
            :loading="blockW"
            class="h-350px"
          />
          <span class="fs-6 text-gray-600"> {{ translate("dashboard_no_planned_audit_week") }}</span>
        </div>

        <div
          v-else
          class="h-350px position-relative"
        >
          <BlockUI
            :loading="blockW"
            class="h-300px"
          />
          <div class="h-300px overflow-auto">
            <div
              class="d-flex align-items-center rounded p-2"
              v-for="audit in weekAuditList"
              :key="audit"
            >
              <span class="bullet bullet-vertical h-40px bg-primary"></span>
              <div class="form-check form-check-custom form-check-solid mx-5">
                <a
                  v-if="audit.StatusCode == 30"
                  :title="translate('dashboard_completed_audit')"
                >
                  <i class="bi bi-check-circle-fill text-primary fs-2"></i
                ></a>
                <a
                  v-else-if="isInThePast(new Date(formatDate(audit.AuditDateTime)))"
                  :title="translate('dashboard_card_icon_out_of_date')"
                >
                  <i class="bi bi-x-circle-fill text-danger fs-2"></i
                ></a>
                <a
                  v-else
                  :title="translate('dashboard_card_icon_upcoming_audit')"
                >
                  <i class="bi bi-clock text-primary fs-2"></i
                ></a>
              </div>
              <div class="flex-grow-1">
                <a class="text-gray-800 text-hover-primary fw-bolder fs-6">{{ audit.CustomerName }}</a
                ><span class="text-muted fw-bold d-block">
                  {{ audit.LocationName }}
                </span>
              </div>
              <span class="badge fs-8 fw-bolder badge-light-primary">{{ audit.AuditDateTime.substr(0, 16) }} </span>
            </div>
          </div>

          <div class="mt-3 d-flex">
            <Pagination
              @onPage="onPageW"
              :TotalData="totalCountWeek"
            />
          </div>
        </div>
      </div>

      <div
        class="tab-pane fade"
        id="nav-contact"
        role="tabpanel"
        aria-labelledby="nav-profile-tab"
      >
        <div
          class="h-350px w-100 d-flex align-items-center justify-content-center position-relative"
          v-if="totalCountMonth == 0"
        >
          <BlockUI
            :loading="blockM"
            class="h-350px"
          />
          <span class="fs-6 text-gray-600"> {{ translate("dashboard_no_planned_audit_month") }}</span>
        </div>

        <div
          v-else
          class="h-350px text-gray-600 position-relative"
        >
          <BlockUI
            :loading="blockM"
            class="h-300px"
          />

          <div class="h-300px overflow-auto">
            <div
              class="d-flex align-items-center rounded p-2"
              v-for="audit in monthAuditList"
              :key="audit"
            >
              <span class="bullet bullet-vertical h-40px bg-primary"></span>
              <div class="form-check form-check-custom form-check-solid mx-5">
                <a
                  v-if="audit.StatusCode == 30"
                  :title="translate('dashboard_completed_audit')"
                >
                  <i class="bi bi-check-circle-fill text-primary fs-2"></i
                ></a>
                <a
                  v-else-if="isInThePast(new Date(formatDate(audit.AuditDateTime)))"
                  :title="translate('dashboard_card_icon_out_of_date')"
                >
                  <i class="bi bi-x-circle-fill text-danger fs-2"></i
                ></a>
                <a
                  v-else
                  :title="translate('dashboard_card_icon_upcoming_audit')"
                >
                  <i class="bi bi-clock text-primary fs-2"></i
                ></a>
              </div>
              <div class="flex-grow-1">
                <span class="text-gray-800 fw-bolder fs-6">{{ audit.CustomerName }}</span
                ><span class="text-muted fw-bold d-block">
                  {{ audit.LocationName }}
                </span>
              </div>
              <span class="badge fs-8 fw-bolder badge-light-primary">{{ audit.AuditDateTime.substr(0, 16) }} </span>
              {{}}
            </div>
          </div>

          <div class="mt-3 d-flex">
            <Pagination
              @onPage="onPageM"
              :TotalData="totalCountMonth"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
const totalCountDay = ref(0);
const totalCountWeek = ref(0);
const totalCountMonth = ref(0);
const dayAuditList = ref([]);
const weekAuditList = ref([]);
const monthAuditList = ref([]);
const blockD = ref(true);
const blockW = ref(true);
const blockM = ref(true);

const store = useStore();
const getDayAudit = (pageIndex, pageSize) => {
  let obj = {
    pageIndex: pageIndex,
    pageSize: pageSize,
  };
  store
    .dispatch("DashboardModule/GET_DAY_AUDIT", obj)
    .then((response) => {
      totalCountDay.value = response.TotalItemsCount;
      dayAuditList.value = response.ListItems;
    })
    .finally(() => {
      blockD.value = false;
    });
};
const getWeekAudit = (pageIndex, pageSize) => {
  let obj = {
    pageIndex: pageIndex,
    pageSize: pageSize,
  };
  store.dispatch("DashboardModule/GET_WEEK_AUDIT", obj).then((response) => {
    totalCountWeek.value = response.TotalItemsCount;
    weekAuditList.value = response.ListItems;
    if (response) {
      blockW.value = false;
    }
  });
};
const getMonthAudit = (pageIndex, pageSize) => {
  let obj = {
    pageIndex: pageIndex,
    pageSize: pageSize,
  };
  store
    .dispatch("DashboardModule/GET_MONTH_AUDIT", obj)
    .then((response) => {
      totalCountMonth.value = response.TotalItemsCount;
      monthAuditList.value = response.ListItems;
    })
    .finally(() => {
      blockM.value = false;
    });
};
const lazyParams = ref([]);
lazyParams.value = {
  pageD: 1,
  pageSizeD: 10,
  pageW: 1,
  pageSizeW: 10,
  pageM: 0,
  pageSizeM: 10,
};

function isInThePast(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return date < today;
}

function formatDate(date) {
  let year = date.substr(6, 4);
  let month = date.substr(3, 2);
  let day = date.substr(0, 2);

  return [year, month, day].join("-");
}

const onPageD = (e) => {
  lazyParams.value.pageD = e.step.value;
  lazyParams.value.pageSizeD = e.pageSize.value;
  getDayAudit(lazyParams.value.pageD, lazyParams.value.pageSizeD);
};

const onPageW = (e) => {
  lazyParams.value.pageW = e.step.value;
  lazyParams.value.pageSizeW = e.pageSize.value;
  getWeekAudit(lazyParams.value.pageW, lazyParams.value.pageSizeW);
};
const onPageM = (e) => {
  lazyParams.value.pageM = e.step.value;
  lazyParams.value.pageSizeM = e.pageSize.value;
  getMonthAudit(lazyParams.value.pageM, lazyParams.value.pageSizeM);
};
getDayAudit(1, 10);
getWeekAudit(1, 10);
getMonthAudit(1, 10);
</script>
